/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class ColonyRequest extends MainRequest{

    static addColony(data, token){
        return this.postSEC(ServicePath.COLONY_ADD, data)
    }

    static listAllColony(data, token){
        return this.postSEC(ServicePath.COLONY_LIST_ALL, data)
    }

    static updateColony(data, token){
        return this.postSEC(ServicePath.COLONY_UPDATE, data)
    }

    static deleteColony(data, token){
        return this.postSEC(ServicePath.COLONY_DELETE, data)
    }

}